

export const required = { value: true, errorMessage: 'Campo obrigatório!' };

export const minLength = { value: 1, errorMessage: 'Verifique o valor! ' };